import {BaseApiResponseModel} from "./base-api-response-model";
import {BaseApiRequestParams} from "./params/base-api-request-params";
import {BaseModel} from "./base-model";

export class BaseApiRequestModel extends BaseModel {
  url: String;
  params: BaseApiRequestParams;
  promise: Promise<BaseApiResponseModel>;
  response: BaseApiResponseModel;
  callbacks: Object;

  constructor(url: String, params: BaseApiRequestParams, promise: Promise<BaseApiResponseModel>, response: BaseApiResponseModel) {
    super();

    this.url = url;
    this.params = params;
    this.promise = promise;
    this.response = response;
    this.callbacks = {};
  }
}